import moment from 'moment';

export const getFormattedDateRange = (
  effectivedate = '',
  inactivedate = ''
): string => {
  const formattedEffectiveDate = moment.utc(effectivedate).format('MM/DD/YYYY');
  const formattedInactiveDate = inactivedate
    ? ` - ${moment.utc(inactivedate).format('MM/DD/YYYY')}`
    : '';
  return `${formattedEffectiveDate}${formattedInactiveDate}`;
};

export const parseEffectiveDateSort = (
  isoString: string | null | undefined
): Date | null => {
  if (!isoString) return null;
  const date = moment.utc(isoString).toDate();
  return isNaN(date.getTime()) ? null : date;
};

export const capitalizeWords = (str = '') => {
  if (!str || typeof str !== 'string') return '';
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
